import { EntityFilters } from '@apps/prtg/models';
import { StatusesMetadata } from '@common/models';

export const BackPrtgFeatureKey = 'prtg';

export interface IBackPrtgState extends StatusesMetadata
{
    entityFilters: EntityFilters;
    noContent?: boolean;
    filters: string[];
}

export const BackPrtgInitialState: IBackPrtgState = {
    entityFilters: null,
    noContent: null,
    ...StatusesMetadata.init(),
    filters: []
};
